import React from 'react';
export default function GasMaskSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Main face plate */}
      <path d="M8 12 C8 8 14 4 20 4 C26 4 32 8 32 12 L32 28 C32 34 26 38 20 38 C14 38 8 34 8 28 Z" fill="#455A64" />
      <path d="M9 13 C9 9 14 5 20 5 C26 5 31 9 31 13 L31 27 C31 33 26 37 20 37 C14 37 9 33 9 27 Z" fill="#546E7A" />

      {/* Eye lenses */}
      <circle cx="14" cy="16" r="5" fill="#37474F" />
      <circle cx="14" cy="16" r="4" fill="#263238" />
      <circle cx="26" cy="16" r="5" fill="#37474F" />
      <circle cx="26" cy="16" r="4" fill="#263238" />

      {/* Lens reflections */}
      <circle cx="12.5" cy="14.5" r="1.2" fill="#78909C" opacity="0.4" />
      <circle cx="24.5" cy="14.5" r="1.2" fill="#78909C" opacity="0.4" />

      {/* Nose bridge */}
      <rect x="18" y="14" width="4" height="6" rx="1" fill="#37474F" />

      {/* Snout / respirator */}
      <ellipse cx="20" cy="30" rx="6" ry="5" fill="#37474F" />
      <ellipse cx="20" cy="30" rx="5" ry="4" fill="#455A64" />

      {/* Respirator vents */}
      <rect x="16" y="28" width="8" height="1" rx="0.5" fill="#263238" />
      <rect x="16" y="30" width="8" height="1" rx="0.5" fill="#263238" />
      <rect x="16" y="32" width="8" height="1" rx="0.5" fill="#263238" />

      {/* Side filter canisters */}
      <circle cx="4" cy="24" r="4" fill="#546E7A" />
      <circle cx="4" cy="24" r="3" fill="#455A64" />
      <circle cx="4" cy="24" r="1.5" fill="#37474F" />
      <circle cx="36" cy="24" r="4" fill="#546E7A" />
      <circle cx="36" cy="24" r="3" fill="#455A64" />
      <circle cx="36" cy="24" r="1.5" fill="#37474F" />

      {/* Straps */}
      <path d="M8 14 L4 12" stroke="#37474F" strokeWidth="2" strokeLinecap="round" />
      <path d="M32 14 L36 12" stroke="#37474F" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
